import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useI18n } from 'vue-i18n';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import { getInsuranceTypeDisplayName, InsuranceQuoteType, QuoteTypeCodes } from '@/interfaces';


export default /*@__PURE__*/_defineComponent({
  __name: 'MembershipBenefits',
  props: {
    membershipBenefit: {},
    showIcons: { type: Boolean },
    quoteType: {}
  },
  setup(__props: any) {

const translation = useI18n();
const dictionary: Record<string, string> = translation.getLocaleMessage('en') as any;

const props = __props;

function formatText(text: string) {
  if (!text) return text;
  return text.replaceAll('{0}', getInsuranceTypeDisplayName(dictionary, QuoteTypeCodes[props.quoteType], true));
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(RichText), {
      field: _ctx.membershipBenefit?.fields.membershipBenefitHeading,
      class: "text-lg-bold pb-5"
    }, null, 8, ["field"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.membershipBenefit.benefits, (mb, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createVNode(_unref(RichText), {
          field: { value: mb.fields.membershipBenefitHeading.value },
          class: "text-lg-bold pb-3"
        }, null, 8, ["field"]),
        _createVNode(_unref(RichText), {
          field: { value: formatText(mb?.fields.membershipBenefitSummaryText.value) },
          class: "text-base"
        }, null, 8, ["field"])
      ]))
    }), 128))
  ], 64))
}
}

})